
<div class="popup-model popup-lg shadow top">
  <div class="d-flex justify-content-between align-items-center pink-header P-2">
    <h5 class="flex-grow-1 text-center mt-1">{{ 'DELIVERY.MODIFY_LOAD' | translate }}</h5>
    <div data-svg-wrapper style="position: relative" class="p-1">
      <button class="btn p-0 d-flex align-items-center" (click)="close()">
        <img src="assets/icon/close.svg" />
      </button>
    </div>
  </div>
  <div class="p-4 scrollable-container">
    <div class="d-flex justify-content-left m-2" style="gap: 20px;">
      <button class="btn p-0 d-flex align-items-center" (click)="setTab('delivery')">
        <span [ngClass]="{'highlighted-div': selectedTab() === 'delivery'}">{{ 'DELIVERY.DELIVERY' | translate }}</span>
      </button>

      <button class="btn p-0 d-flex align-items-center" (click)="setTab('holes')">
        <span [ngClass]="{'highlighted-div': selectedTab() === 'holes'}">{{ 'DELIVERY.HOLES' | translate }}</span>
      </button>
    </div>

    @if (deliveryParams()) {
      <div>
        <div [ngStyle]="{ display: selectedTab() === 'delivery' ? 'block' : 'none' }"
          style="margin-top: 1.5rem; padding: 1rem;">
          <app-modify-load [form]="$any(modifyLoadForm.get('deliveryForm'))" [deliveryParams]="deliveryParams()"
            [currentSiteId]="currentSiteId()"
            [currentDelivery]="jsonDelivery"
            [blastId]="delivery.tirId"
            (moveDelivery)="moveDelivery($event)"
            (updateDelivery)="submit()"
            (mergeDelivery)="mergeDeliveries($event)"
          (close)="close()"></app-modify-load>
        </div>
        <div [ngStyle]="{ display: selectedTab() === 'holes' ? 'block' : 'none' }" style="margin-top: 1.5rem;">
          <app-modify-hole [holesDeliveryControl]="$any(modifyLoadForm.get('holesDeliveryForm'))"
            [deliveryParams]="deliveryParams()"
            [totalHolesCount]="allHoles().length"
            [currentLoadedCount]="currentLoadedCount()"
            [isScrollLoading]="isLoading()"
            (splitDelivery)="splitDelivery($event)"
            (updateDelivery)="submit($event)"
          (loadMoreHoles)="loadMoreHoles()"></app-modify-hole>
        </div>
      </div>
    }
  </div>

  @if (hasDeleteDeliveryRole()) {
    <div class="delivery-modal-footer">
      <button type="button" class="btn btn-sm btn-link text-danger" (click)="deleteDelivery()"
        title="{{ 'GLOBAL.SUPPRIMER' | translate }}" attr.aria-label="{{ 'GLOBAL.SUPPRIMER' | translate }}">
        <i class="fas fa-trash"></i>
      </button>
    </div>
  }
</div>

@if (showDeleteConfirmation()) {
  <div class="modal-overlay">
    <div class="modal-content delete-confirm-content">
      <i class="fas fa-exclamation-triangle delivery-delete-warning-icon"></i>
      <h5 class="delivery-delete-title">{{ 'DELIVERIES.DELETE_CONFIRM_TITLE' | translate }}</h5>
      <p class="delivery-delete-name">{{ delivery.name || 'N/A' }} — {{ delivery.startTime | date:'dd/MM/yyyy' }}</p>
      <div class="alert-info-custom delivery-delete-warning-text">
        <i class="fas fa-exclamation-triangle"></i>
        {{ 'DELIVERIES.DELETE_IRREVERSIBLE_WARNING' | translate }}
        <div class="delivery-delete-summary">
          <span>{{ 'DELIVERIES.HOLE_COUNT' | translate }} : {{ delivery.holeCount }}</span>
          <span>{{ 'DELIVERIES.KGSEND' | translate }} : {{ delivery.kgDelivered }}</span>
        </div>
      </div>
      <div class="d-flex justify-content-center pt-1 text-center" style="gap: 20px; margin-top: 1rem;">
        <button type="button" class="btn btn-sm btn-secondary w-30" [disabled]="isDeletingDelivery()"
          (click)="cancelDeleteDelivery()">{{ 'GLOBAL.ANNULER' | translate }}</button>
        <button type="button" class="btn btn-sm btn-primary w-30" [disabled]="isDeletingDelivery()"
          (click)="confirmDeleteDelivery()">
          @if (isDeletingDelivery()) {
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          }
          {{ 'GLOBAL.CONFIRMER' | translate }}
        </button>
      </div>
    </div>
  </div>
}
